// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `Coupon Code`
};

const de_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `Gutscheincode`
};

const es_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `Código de Cupón`
};

const fr_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `Code Promo`
};

const fi_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `Kuponkikoodi`
};

const ja_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `クーポンコード`
};

const nl_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `Couponcode`
};

const pt_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `Código do cupom`
};

const ro_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `Cod cupon`
};

const th_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `รหัสคูปอง`
};

const ur_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `کوپن کوڈ`
};

const zh_hant1_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `優惠券代碼`
};

const da_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `Rabatkode`
};

const it_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `Codice Coupon`
};

const vn_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `Mã Giảm Giá`
};

const ko_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `쿠폰 코드`
};

const tr_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `Kupon Kodu`
};

const lv_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `Kupona kods`
};

const ar_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `رمز الكوبون`
};

const bs_widget_coupon_code = /** @type {(inputs: {}) => string} */ () => {
	return `Kod kupona`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_coupon_code = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_coupon_code(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_coupon_code", locale)
	if (locale === "en") return en_widget_coupon_code(inputs)
	if (locale === "de") return de_widget_coupon_code(inputs)
	if (locale === "es") return es_widget_coupon_code(inputs)
	if (locale === "fr") return fr_widget_coupon_code(inputs)
	if (locale === "fi") return fi_widget_coupon_code(inputs)
	if (locale === "ja") return ja_widget_coupon_code(inputs)
	if (locale === "nl") return nl_widget_coupon_code(inputs)
	if (locale === "pt") return pt_widget_coupon_code(inputs)
	if (locale === "ro") return ro_widget_coupon_code(inputs)
	if (locale === "th") return th_widget_coupon_code(inputs)
	if (locale === "ur") return ur_widget_coupon_code(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_coupon_code(inputs)
	if (locale === "da") return da_widget_coupon_code(inputs)
	if (locale === "it") return it_widget_coupon_code(inputs)
	if (locale === "vn") return vn_widget_coupon_code(inputs)
	if (locale === "ko") return ko_widget_coupon_code(inputs)
	if (locale === "tr") return tr_widget_coupon_code(inputs)
	if (locale === "lv") return lv_widget_coupon_code(inputs)
	if (locale === "ar") return ar_widget_coupon_code(inputs)
	if (locale === "bs") return bs_widget_coupon_code(inputs)
	return "widget_coupon_code"
};